<app-dialog-heading [heading]="'Cases'"></app-dialog-heading>

<ng-container *ngIf="isDataExist;
                  then showCases else emptyCasesDataTable"></ng-container>
<ng-template #showCases>
  <div class="mat-elevation-z8 table-container">
    <table (matSortChange)="sortData($event)" [dataSource]="casesDataSource" mat-table
           matSort multiTemplateDataRows>
      
      <ng-container [matColumnDef]="tableColumns.CaseId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Case Number</th>
        <td *matCellDef="let row" mat-cell> {{row.caseId}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.ProcessingClass">
        <th *matHeaderCellDef class="w-10" mat-header-cell mat-sort-header>Class</th>
        <td *matCellDef="let row" mat-cell> {{row.processingClass?.name}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.Name">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Case Name</th>
        <td *matCellDef="let row" [matTooltip]="row.name"
            mat-cell>
          {{row.name | truncateText: {sliceEnd: 50, completeWords: true, append: '...'} }}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.StartDate">
        <th *matHeaderCellDef class="w-10" mat-header-cell mat-sort-header>Start Date</th>
        <td *matCellDef="let row" mat-cell> {{row.startDate | date: dateFormat}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.InsuredPerson">
        <th *matHeaderCellDef class="w-20" mat-header-cell mat-sort-header>Member</th>
        <td *matCellDef="let row" mat-cell>
          {{row.insuredPerson?.name}}
        </td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.ElapsedDays">
        <th *matHeaderCellDef class="w-20" mat-header-cell> Elapsed Days</th>
        <td *matCellDef="let row" mat-cell>
          <ng-container *ngIf="row.caseStatus === caseStatus.Open">
            {{row.startDate | timeElapsedFromNow: true }}
          </ng-container>
        </td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.CaseStatus">
        <th *matHeaderCellDef mat-header-cell> Case Status</th>
        <td *matCellDef="let row" mat-cell> {{row.caseStatus}}</td>
      </ng-container>
      
      <ng-container [matColumnDef]="tableColumns.CaseManager">
        <th *matHeaderCellDef mat-header-cell> Case Manager</th>
        <td *matCellDef="let row" mat-cell> {{row.caseManager}}</td>
      </ng-container>
      
      <!--Expanded Section -->
      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let row" [attr.colspan]="casesDisplayedColumns.length" mat-cell>
          <div [@detailExpand]="row == caseExpandedRow ? 'expanded' : 'collapsed'"
               class="row-detail-container">
            <b>Created By: </b>{{row.createdBy}}<br>
            <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
            <b>Updated By: </b>{{row.updatedBy}}<br>
            <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
          </div>
        </td>
      </ng-container>
      
      <tr *matHeaderRowDef="casesDisplayedColumns;" mat-header-row></tr>
      <tr (click)="caseExpandedRow = caseExpandedRow === row ? null : row"
          *matRowDef="let row; columns: casesDisplayedColumns;"
          [class.expanded-row]="caseExpandedRow == row"
          class="row"
          mat-row>
      </tr>
      <tr *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row" mat-row></tr>
    </table>
    
    <mat-paginator #casePaginator (page)="pageChanged($event)"
                   [length]="caseTableControl.length" [pageIndex]="0"
                   [pageSizeOptions]="caseTableControl.pageSizeOptions"
                   [pageSize]="caseTableControl.pageSize">
    </mat-paginator>
  </div>
</ng-template>


<ng-template #emptyCasesDataTable>
  <div class="text-center">
    <label class="column-label claim-column-label">No case data</label>
  </div>
</ng-template>
